// Consulta compartida para /bienvenidopanel.
// El navbar y el panel de bienvenida piden los mismos datos y sus componentes se montan varias veces
// por carga de pagina, por lo que cada montaje repetia el POST contra un endpoint costoso.
// Este helper agrupa esas solicitudes en una sola durante una ventana corta.

export const VIGENCIA_BIENVENIDO_PANEL_MS = 30000;

let entrada = null;

const construirClave = (url, token) => `${url}|${token}`;

const descartarSiEs = (solicitud) => {
  if (entrada && entrada.solicitud === solicitud) {
    entrada = null;
  }
};

/**
 * Devuelve la solicitud compartida del panel de bienvenida.
 * Resuelve con { ok, datos, error } para que cada consumidor conserve su propio manejo de errores.
 */
export const obtenerBienvenidoPanel = (url, token) => {
  const clave = construirClave(url, token);
  const ahora = Date.now();

  if (entrada && entrada.clave === clave && ahora < entrada.vence) {
    return entrada.solicitud;
  }

  const solicitud = fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  })
    .then((response) =>
      response
        .json()
        .then((datos) => ({ ok: response.ok, datos, error: null }))
        .catch((error) => ({ ok: response.ok, datos: null, error }))
    )
    .catch((error) => {
      // Una falla de red no debe quedar servida durante toda la ventana.
      descartarSiEs(solicitud);
      throw error;
    });

  entrada = {
    clave,
    solicitud,
    vence: ahora + VIGENCIA_BIENVENIDO_PANEL_MS,
  };

  return solicitud;
};

/** Limpia la ventana compartida; se usa en los tests. */
export const reiniciarBienvenidoPanel = () => {
  entrada = null;
};
